<template>
   <div>
      <div class="block block--visible">
         <div class="block__content">
            <div class="row">

               <PersonalData/>

               <!-- User PAYMENT info change -->
               <div class="col-12 col-lg-4 account__userdata__col">
                  <div class="account__block__title mb-3">{{ t('user.page.data.contact') }}</div>

                  <SecretQuestion/>
                  <hr class="account__block__hr">

                  <PaymentAccount/>

               </div>

               <!--User PASSWORD change form-->
               <div class="col-12 col-lg-4 account__userdata__col">
                  <Password/>

                  <NewsLetter/>

               </div>

            </div>
         </div>
      </div>
   </div>

</template>
<script>
import Vuex from 'vuex';
import VeeInput from '@/components/ValidateInput';
import FormMessage from '@/components/parts/form-message';

import PersonalData from './personal_data'
import SecretQuestion from './secret_question';
import PaymentAccount from './payment_account';
import Password from './password';
import NewsLetter from './newsletter';



// import moment from 'moment-timezone';
// import {regex} from '@/config';
// import {mask} from 'vue-the-mask';
// import _ from 'lodash';

export default {
   name: 'UserData',
   //directives: {mask},
   beforeRouteEnter(to, from, next) {
      next();


   },
   data() {
      return {

         loading: [],

         initialModal: false,

         /*form: {
            cin: {
               file: [],
               phone: ''
            },
            question: {
               value: '',
               answer: '',
               active: false
            },
            iban: {
               value: '',
               file: [],
               regex: regex.iban
            },
            password: {
               p0: '',
               p1: '',
               p2: '',
               validity1: {
                  required: true,
                  min: 6,
                  regex: regex.password
               },
               validity2: {
                  required: true,
                  min: 6,
                  confirmed: 'passwordNew'
               }
            },
            newsletter: false
         }*/
      }
   },
   components: {
      VeeInput,
      FormMessage,

      PersonalData,
      SecretQuestion,
      PaymentAccount,
      Password,
      NewsLetter

   },
   computed: {
      ...Vuex.mapState([
         'lang',
         'loaderList'
      ]),
      ...Vuex.mapGetters({
         user: 'getUser',
         userLogedIn: 'getUserStatus',
         details: 'getUserDetails'
      }),






   },

   mounted() {



      //window.ud = this;
   },
   methods: {



      /*setCities(data) {
         this.cities = data;
      },
      formatCity(option) {
         return option.name
      },*/





   }


}
</script>
